import React from 'react';
import ReactGA from 'react-ga';

import { Page } from '../components';
import { FormContent, PrimaryContent } from '../components/Content/QualificationScreen';

ReactGA.pageview(window.location.pathname + window.location.search);

const QualificationScreen = () => (
  <Page id="main">
    <PrimaryContent />
    <FormContent />
  </Page>
);

export default QualificationScreen;
